import api from "@/requests";

export const getAvailableLimit = () =>
  api.get("api/v1/Myred/RedAvailableLimit", {
    showLoader: false,
    showAlert: false,
  });

export const getRedLimitStatus = (payload) =>
  api.post("api/v1/Myred/GetRedLimitStatus", payload, {
    showLoader: false,
    showAlert: false,
  });

export const setRedLimit = (payload) =>
  api.post("api/v1/Myred/SetRedLimit", payload);

